<main>
  <app-password-change [caducada]="true"></app-password-change>
</main>